module.exports = __webpack_public_path__ + "static/media/CTG-Ride_logo_dark.298053f0.svg";